import React, { useCallback, useRef, useMemo, useState } from "react"
import styles from "./PeriodSlider.module.scss"
import Picker from "react-month-picker"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { MakeMonthName, convertToMoment, MonthNames, BuildYears } from "modules/common/models/period"

export const PeriodSlider: React.FC<PeriodSliderProps> = (props) => {
    const { month, year, onChange } = props

    const pickerRef = useRef<any>()
    // Ручной контроль видимости окна — теперь оно никогда не закроется само при смене года
    const [isOpen, setIsOpen] = useState(false)

    const gotoNextMonth = useCallback(() => {
        const next = convertToMoment(month, year).add(1, "month")
        onChange(next.year(), next.month() + 1)
    }, [month, year, onChange])

    const gotoPreviousMonth = useCallback(() => {
        const prev = convertToMoment(month, year).subtract(1, "month")
        if (prev.isValid()) {
            onChange(prev.year(), prev.month() + 1)
        }
    }, [month, year, onChange])

    const onMonthChange = useCallback(
        (y: number, m: number) => {
            onChange(y, m)
            setIsOpen(false)

        },
        [onChange]
    )

    const togglePicker = useCallback((e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        setIsOpen((prev) => !prev)
    }, [])

    const yearsOptions = useMemo(() => {
        try {
            return BuildYears(year) || [year]
        } catch {
            return [year]
        }
    }, [year])

    const monthName = useMemo(() => MakeMonthName(month), [month])

    return (
        <div className={`period-slider ${styles.slider}`} onClick={(e) => e.stopPropagation()}>
            <PlanrButton type="neutral" icon="general-big-arrow-left" onClick={gotoPreviousMonth} size="small" />

            <div className={styles.monthName} onClick={togglePicker}>
                <span className={styles.value} >
                    &nbsp;{monthName}&nbsp;
                </span>
                <div className={styles.year}>{year}</div>

                {isOpen && (

                    <Picker
                        ref={pickerRef}
                        years={yearsOptions}
                        value={{ month, year }}
                        lang={MonthNames}
                        onChange={onMonthChange}
                        show={true}
                    />
                )}
            </div>

            <PlanrButton type="neutral" icon="general-big-arrow-right" onClick={gotoNextMonth} size="small" />
        </div>
    )
}

interface PeriodSliderProps {
    month: number
    year: number
    onChange: (year: number, month: number) => void
}
